if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      
      // Debug: Log the data-end-date attribute
      console.log('Countdown Timer - data-end-date:', this.dataset.endDate);
      
      this.endDate = new Date(this.dataset.endDate).getTime();
      console.log('Countdown Timer - parsed endDate:', this.endDate);
      
      if (!Number(this.endDate) || isNaN(this.endDate)) {
        console.error('Invalid end date:', this.dataset.endDate);
        return;
      }

      // Check section visibility
      this.checkSectionVisibility();

      // Initialize immediately or with lazy loading
      if (window.initLazyScript && typeof window.initLazyScript === 'function') {
        // scrolling banner coordinates loading
        if (!this.closest('.marquee-item')) {
          window.initLazyScript(this, this.init.bind(this));
        }
      } else {
        // If initLazyScript doesn't exist, initialize immediately
        console.log('initLazyScript not found, initializing immediately');
        this.init();
      }
    }

    checkSectionVisibility() {
      const section = this.closest('[data-countdown-section]');
      if (!section) return;

      const startDateStr = section.dataset.startDate;
      const endDateStr = section.dataset.endDate;
      
      if (!startDateStr && !endDateStr) return;

      const checkAndToggle = () => {
        const now = Date.now();
        const startDate = startDateStr ? new Date(startDateStr).getTime() : null;
        const endDate = endDateStr ? new Date(endDateStr).getTime() : null;
        
        let shouldShow = true;
        
        if (startDate && now < startDate) {
          shouldShow = false;
        }
        
        if (endDate && now > endDate) {
          shouldShow = false;
        }

        section.style.display = shouldShow ? '' : 'none';
        
        if (!shouldShow) {
          if (this.interval) clearInterval(this.interval);
          if (this.visibilityInterval) clearInterval(this.visibilityInterval);
        }
      };

      checkAndToggle();
      this.visibilityInterval = setInterval(checkAndToggle, 1000);
    }

    init() {
      console.log('Countdown Timer - init called');
      
      this.daysEl = this.querySelector('.js-days .countdown__number-part');
      this.hoursPart1El = this.querySelector('.js-hours .countdown__number-part-1');
      this.hoursPart2El = this.querySelector('.js-hours .countdown__number-part-2');
      this.minsPart1El = this.querySelector('.js-mins .countdown__number-part-1');
      this.minsPart2El = this.querySelector('.js-mins .countdown__number-part-2');
      this.secsPart1El = this.querySelector('.js-secs .countdown__number-part-1');
      this.secsPart2El = this.querySelector('.js-secs .countdown__number-part-2');

      console.log('Countdown Timer - elements found:', {
        daysEl: !!this.daysEl,
        hoursPart1El: !!this.hoursPart1El,
        hoursPart2El: !!this.hoursPart2El
      });

      if (!this.daysEl || !this.hoursPart1El || !this.hoursPart2El) {
        console.error('Countdown Timer - Required elements not found!');
        return;
      }

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      const numberTransitionDuration = getComputedStyle(this).getPropertyValue('--countdown-number-transition-duration');
      if (numberTransitionDuration) {
        this.numberTransitionDurationMS = CountdownTimer.durationToMS(numberTransitionDuration);
        this.animated = this.numberTransitionDurationMS > 0;
      }

      // add transition elements
      if (this.animated) {
        this.querySelectorAll('.countdown__number:is(.js-hours, .js-mins, .js-secs) .countdown__number-part').forEach((el) => {
          el.innerHTML = '';
          const span1 = document.createElement('span');
          span1.className = 'countdown__number-part-current';
          span1.textContent = '0';
          const span2 = document.createElement('span');
          span2.className = 'countdown__number-part-previous';
          span2.textContent = '0';
          el.append(span1, span2);
        });
      }

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
      this.setAttribute('loaded', '');
      console.log('Countdown Timer - initialization complete');
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        this.setAttribute('loaded', '');
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      if (days === 0) {
        this.daysEl.closest('.countdown__item').classList.add('countdown__item--is-0');
        this.daysEl.classList.add('countdown__number-part--is-0');
      }
      this.daysEl.textContent = days;

      const displayHours = String(hours - days * 24).padStart(2, '0');
      this.setPartValue(this.hoursPart1El, displayHours[0], true);
      this.setPartValue(this.hoursPart2El, displayHours[1]);

      const displayMins = String(mins - hours * 60).padStart(2, '0');
      this.setPartValue(this.minsPart1El, displayMins[0], true);
      this.setPartValue(this.minsPart2El, displayMins[1]);

      const displaySecs = String(secs - mins * 60).padStart(2, '0');
      this.setPartValue(this.secsPart1El, displaySecs[0], true);
      this.setPartValue(this.secsPart2El, displaySecs[1]);

      this.setAttribute('loaded', '');
    }

    setPartValue(part, value, setZeroClass) {
      if (!part) return;
      
      if (setZeroClass) {
        part.classList.toggle('countdown__number-part--is-0', value === '0');
      }

      // Changing value and animated
      if (this.animated) {
        const current = part.querySelector('.countdown__number-part-current');
        if (current && value !== current.textContent) {
          const previous = part.querySelector('.countdown__number-part-previous');
          part.classList.add('countdown__number-part--start-transition');
          previous.textContent = current.textContent;
          current.textContent = value;
          setTimeout(() => {
            requestAnimationFrame(() => part.classList.remove('countdown__number-part--start-transition'));
          }, 20);
        }
      } else {
        part.textContent = value;
      }
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
      if (this.visibilityInterval) clearInterval(this.visibilityInterval);
    }

    static durationToMS(duration) {
      if (duration.indexOf('ms') > 0) {
        return parseInt(duration, 10);
      }

      if (duration.indexOf('s') > 0) {
        return parseFloat(duration) * 1000;
      }

      throw new Error(`Duration unit not recognised: ${duration}`);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
  console.log('Countdown Timer - custom element defined');
}